var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Merchant = (function (Merchant) {

        Merchant.Messages = (function (Messages) {

            Messages.GetModel = function (itemId) {

                var data = {
                    itemId: itemId
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Merchant.Messages.GetModel', data);
            };
            Messages.GetModel.className = 'Vendd.Merchant.Messages.GetModel';

            Messages.GetModelFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Merchant.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.Merchant.Messages.GetModelFailed';

            Messages.GetModelSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Merchant.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.Merchant.Messages.GetModelSuccess';

            return Messages;

        })(Merchant.Messages || {});

        return Merchant;

    })(Vendd.Merchant || {});

    return Vendd;

})(Vendd || {});